module.exports = __webpack_public_path__ + "static/media/Upcoming_Bg.9b3ab412.png";